function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#92BB3E",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.75,16.9384766 C8.30175781,16.9384766 7.96777344,16.7714844 7.66015625,16.4111328 L4.09179688,12.0166016 C3.84570312,11.7265625 3.7578125,11.4716797 3.7578125,11.1816406 C3.7578125,10.53125 4.24121094,10.0654297 4.90039062,10.0654297 C5.29589844,10.0654297 5.56835938,10.1972656 5.83203125,10.5224609 L8.71484375,14.1875 L14.3398438,5.26660156 C14.6123047,4.82714844 14.8935547,4.66894531 15.3505859,4.66894531 C16.0097656,4.66894531 16.484375,5.13476562 16.484375,5.77636719 C16.484375,6.02246094 16.4052734,6.27734375 16.2207031,6.55859375 L9.84863281,16.3671875 C9.59375,16.7539062 9.22460938,16.9384766 8.75,16.9384766 Z",
  id: "\\u2713",
  fill: "#FFFFFF"
})));

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 -1 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.26411736.svg";
export { ForwardRef as ReactComponent };